import { render, staticRenderFns } from "./vehicleBlackWhiteList.vue?vue&type=template&id=436d9983&scoped=true&"
import script from "./vehicleBlackWhiteList.vue?vue&type=script&lang=js&"
export * from "./vehicleBlackWhiteList.vue?vue&type=script&lang=js&"
import style0 from "./vehicleBlackWhiteList.vue?vue&type=style&index=0&id=436d9983&prod&lang=less&scoped=true&"
import style1 from "./vehicleBlackWhiteList.vue?vue&type=style&index=1&id=436d9983&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436d9983",
  null
  
)

export default component.exports